import Container from "@material-ui/core/Container"
import React, { forwardRef, useEffect, useState } from "react"
import styled from "styled-components"
import GoToBtn from "./goToBtn"
import ShareButton from "./shareButton"

interface IProps {
  title: string
}

const Wrapper = styled(Container)`
  position: relative;

  > * + * {
    left: ${({ theme }) => theme.spacing(12)}px !important;
  }
`

const GoTo = styled(GoToBtn)`
  position: absolute;
  top: ${({ theme }) => theme.spacing(4)}px;
  left: ${({ theme }) => theme.spacing(4)}px;
`

const Share = styled(ShareButton)`
  position: absolute;
  top: ${({ theme }) => theme.spacing(4)}px;
  left: ${({ theme }) => theme.spacing(4)}px;
`

const ShareBtn = forwardRef<HTMLElement, IProps>(({ title }, ref) => {
  const [url, setUrl] = useState<false | string>(false)

  useEffect(() => {
    setUrl(window.location.href)
  }, [])

  if (!url) return null

  return (
    <Wrapper maxWidth="md">
      {ref && <GoTo ref={ref} />}
      <Share title={title} url={url} emailBody={title} />
    </Wrapper>
  )
})

export default ShareBtn
